import React, { useEffect, useState } from 'react'
import classes from "./PricingNew.module.css";
import promix from "../../Assets/Promix.svg"
// import marked from "../../Assets/marked.svg"
import marked from "../../Assets/tick.png"
import star from "../../Assets/star.svg"
import { Link, useNavigate, useLocation } from 'react-router-dom';
import axios from "axios";
import { BASE_URL } from "../../Components/API/Api";


const PricingNew = () => {
    const [plans, setPlans] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchPlans = async () => {
        setIsLoading(true);
        setError(null);
        try {
            const response = await axios.get(`${BASE_URL}/v1/get-all-plans`);
            const data = response.data?.data || [];
            setPlans(data);
        } catch (err) {
            console.error("Failed to fetch plans", err);
            setError("Unable to load plans at the moment.");
            setPlans([]);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        // scroll to top whenever this page mounts
        window.scrollTo(0, 0);
        fetchPlans();
    }, []);

    

    const navigate = useNavigate();
    const location = useLocation();
    const companyId = location?.state?.company_id || null;
    const industryId = location?.state?.industryId || localStorage.getItem("industryId") || localStorage.getItem("selectedIndustryId") || null;

    const freePlan = plans.find((plan) => plan.name === "Free");
    const basicPlan = plans.find((plan) => plan.name === "Basic Plan");
    const standardPlan = plans.find((plan) => plan.name === "Standard Plan");

    const formatMonthlyPrice = (plan) => {
        if (!plan || plan.monthly == null) return "₦0";
        const value = parseFloat(plan.monthly);
        if (Number.isNaN(value)) return "₦0";
        return `₦${value.toLocaleString("en-US", {
            minimumIntegerDigits: 1,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        })}`;
    };

    return (
        <div>
            <div className={classes.vitchri}>
                <div>
                    <img src={promix} />
                </div>

                <div className={classes.busy}>
                    <p className={classes.gate}>Features</p>
                    <p className={classes.gate}>Pricing</p>
                    <p className={classes.gate}>Resources</p>

                    <button className={classes.bu_tton}>Start Free Trial</button>
                </div>
            </div>

            <div className={classes.pirates}>
               Your Perfect Plan
            </div>

            <p className={classes.ship}>Start free, scale effortlessly. Every plan <br /> includes our complete core features.
            </p>

            

            <div className={classes.medor}>
                <div className={classes.mentorship}>
                    <p className={classes.patriot}>{freePlan?.name || "Starter"}</p>
                    <div className={classes.members}>
                        <p className={classes.organ}>{formatMonthlyPrice(freePlan)}</p>
                        <p className={classes.decept}>/month</p>
                    </div>
                    <p className={classes.mogurn}>{freePlan?.use || "For freelancers and solo enterpreneurs"}
                    </p>

                    <div className={classes.mention}>
                        <div className={classes.condurn}>
                            {freePlan?.priviledges && freePlan.priviledges.length > 0 ? (
                                freePlan.priviledges.map((privilege, index) => (
                                    <div
                                        key={index}
                                        className={index === 0 ? classes.manga2 : classes.manga}
                                    >
                                        <img src={marked} style={{ width: "24px", height: "24px" }} />
                                        <p className={classes.peter}>{privilege}</p>
                                    </div>
                                ))
                            ) : (
                                <div className={classes.manga2}>
                                    <img src={marked} style={{ width: "24px", height: "24px" }} />
                                    <p className={classes.peter}>1 User</p>
                                </div>
                            )}

                            <Link to="/modules"><button className={classes.negate2}>Get Started for Free</button></Link>
                        </div>
                    </div>

                </div>



                <div className={classes.mentorship2}>
                    <div className={classes.popular}>
                        <img src={star}/>
                        <p>Most Popular</p>
                    </div>
                    <p className={classes.patriot}>{basicPlan?.name || "Professional"}</p>
                    <div className={classes.members}>
                        <p className={classes.organ}>{formatMonthlyPrice(basicPlan)}</p>
                        <p className={classes.decept}>/month</p>
                    </div>
                    <p className={classes.mogurn}>{basicPlan?.use || "For growing businesses and small teams"}
                    </p>

                    <div className={classes.mention}>
                        <div className={classes.condurn}>
                            {basicPlan?.priviledges && basicPlan.priviledges.length > 0 ? (
                                basicPlan.priviledges.map((privilege, index) => (
                                    <div
                                        key={index}
                                        className={index === 0 ? classes.manga2 : classes.manga}
                                    >
                                        <img src={marked} style={{ width: "24px", height: "24px" }} />
                                        <p className={classes.peter}>{privilege}</p>
                                    </div>
                                ))
                            ) : (
                                <div className={classes.manga2}>
                                    <img src={marked} style={{ width: "24px", height: "24px" }} />
                                    <p className={classes.peter}>5 Users</p>
                                </div>
                            )}

                            <button
                                className={classes.negate2}
                                onClick={() => basicPlan && navigate("/pricing-new-payment", { state: { selectedPlan: basicPlan, company_id: companyId, industryId: industryId } })}
                                disabled={!basicPlan}
                            >
                                Get Started with {basicPlan?.name || "Professional"}
                            </button>
                        </div>
                    </div>

                </div>



                <div className={classes.mentorship}>
                    <p className={classes.patriot}>{standardPlan?.name || "Enterprise"}</p>
                    <div className={classes.members}>
                        <p className={classes.organ}>{formatMonthlyPrice(standardPlan)}</p>
                        <p className={classes.decept}>/month</p>
                    </div>
                    <p className={classes.mogurn}>{standardPlan?.use || "For complex business needs"}
                    </p>

                    <div className={classes.mention}>
                        <div className={classes.condurn}>
                            {standardPlan?.priviledges && standardPlan.priviledges.length > 0 ? (
                                standardPlan.priviledges.map((privilege, index) => (
                                    <div
                                        key={index}
                                        className={index === 0 ? classes.manga2 : classes.manga}
                                    >
                                        <img src={marked} style={{ width: "24px", height: "24px" }} />
                                        <p className={classes.peter}>{privilege}</p>
                                    </div>
                                ))
                            ) : (
                                <div className={classes.manga2}>
                                    <img src={marked} style={{ width: "24px", height: "24px" }} />
                                    <p className={classes.peter}>Unlimited Users</p>
                                </div>
                            )}

                            <button
                                className={classes.negate2}
                                onClick={() => standardPlan && navigate("/pricing-new-payment", { state: { selectedPlan: standardPlan, company_id: companyId, industryId: industryId } })}
                                disabled={!standardPlan}
                            >
                                Get Started with {standardPlan?.name || "Enterprise"}
                            </button>
                        </div>
                    </div>

                </div>

            </div>

            <p className={classes.proeterw}>Trusted by 10,000+ businesses worldwide</p>
            <div className={classes.pitfall}>
                <div className={classes.number_num}>
                    <p className={classes.costat}>₦50B+</p>
                    <p className={classes.prethelr}>Processed Monthly</p>
                </div>
                <div className={classes.number_num}>
                    <p className={classes.costat}>99.9%</p>
                    <p className={classes.prethelr}> Uptime SLA</p>
                </div>
                <div className={classes.number_num}>
                    <p className={classes.costat}>500+</p>
                    <p className={classes.prethelr}>Integrations</p>
                </div>
            </div>
        </div>

    )
}

export default PricingNew;
